/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentMobileDto
 */
export interface NovitusPaymentMobileDto {
    /**
     * Nazwa formy płatności mobilnej/cyfrowej
     * @type {string}
     * @memberof NovitusPaymentMobileDto
     */
    name: string;
    /**
     * Wartość płatności mobilnej jako string numeryczny
     * @type {string}
     * @memberof NovitusPaymentMobileDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentMobileDto interface.
 */
export function instanceOfNovitusPaymentMobileDto(value: object): value is NovitusPaymentMobileDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentMobileDtoFromJSON(json: any): NovitusPaymentMobileDto {
    return NovitusPaymentMobileDtoFromJSONTyped(json, false);
}

export function NovitusPaymentMobileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentMobileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentMobileDtoToJSON(value?: NovitusPaymentMobileDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

